module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('svg:svg', {
    attrs: {
      "viewbox": "0 0 1400 1755"
    }
  }, [_c('svg:image', {
    attrs: {
      "height": "1755",
      "transform": "translate(0 0)",
      "width": "1400",
      "xlink:href": "../images/9781683353232.jpg"
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c1496e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cover.vue
// module id = 54
// module chunks = 0